import { Button, Heading } from "@elaniintc/goes-design-system";
import { useNavigate } from "react-router";

const Page403 = () => {
  const navigate = useNavigate();
  return (
    <div className="flex h-full w-full items-center justify-center">
      <div className="max-w-114 flex flex-col items-center gap-8">
        <div>
          <Heading variant="h6" className="font-geist-mono text-center">
            403
          </Heading>
          <Heading variant="h2" className="text-center">
            Acceso no autorizado
          </Heading>
          <p className="text-base leading-3xl text-body text-center pt-2">
            No tienes permiso para ver esta página. Si crees que se trata de un
            error, contacta a tu administrador para revisar los permisos de tu
            rol.
          </p>
        </div>
        <Button
          variant="quiet"
          className="w-full"
          onClick={() => navigate("/")}
        >
          Volver al inicio
        </Button>
      </div>
    </div>
  );
};

export default Page403;
